import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#002855] text-white py-4 text-center fixed bottom-0 w-full">
      <p className="text-sm">
        © {new Date().getFullYear()} Maverick Blues Football Club Pvt Ltd. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;